import angular from 'angular';

import RwUserClassComponent from './rw-user-class-component';
import { RwUserClassController } from './rw-user-class-controller';

export default angular
  .module('rw-user-class', [])
  .controller('RwUserClassController', RwUserClassController)
  .component('rwUserClass', RwUserClassComponent);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-user-class/rw-user-class-module.js